/* eslint-disable */
import axios from "axios";

export const sections = [
  {
    label: "Launch Site Banner",
    section: "launch-site-banner",
    version: "v2",
    order: 0,
  },
  {
    label: "Navigation",
    section: "navigation",
    version: "v2",
    order: 1,
  },
  {
    label: "Header",
    section: "header",
    version: "v2",
    order: 2,
  },
  {
    label: "Hero",
    section: "hero",
    version: "v2",
    order: 3,
    v2ImageSource: "/hero-v2.png",
    v21ImageSource: "/hero-v2.1.png",
  },
  {
    label: "Logo w/ Text Grid",
    section: "logo-w-text-grid",
    version: "v2",
    order: 4,
    v2ImageSource: "/badges-v2.png",
    v21ImageSource: "/badges-v2.1.png",
  },
  {
    label: "About Us",
    section: "about-us",
    version: "v2",
    order: 5,
    v2ImageSource: "/about-us-v2.png",
    v21ImageSource: "/about-us-v2.1.png",
  },
  {
    label: "Logo Grid",
    section: "logo-grid",
    version: "v2",
    order: 6,
  },
  {
    label: "Our Services",
    section: "our-services",
    version: "v2",
    order: 7,
    v2ImageSource: "/our-services-v2.mov",
    v21ImageSource: "/our-services-v2.1.mov",
  },
  {
    label: "CTA",
    section: "cta",
    version: "v2",
    order: 8,
    v2ImageSource: "/CTA-v2.png",
    v21ImageSource: "/CTA-v2.1.png",
  },
  {
    label: "Get a Quote",
    section: "get_a_quote",
    version: "v2",
    order: 9,
    v2ImageSource: "/get-a-quote-v2.png",
    v21ImageSource: "/get-a-quote-v2.1.png",
  },
  {
    label: "Our Best Work",
    section: "our-best-work",
    version: "v2",
    order: 10,
    // v2ImageSource: "/our-best-work-v2.mov",
    // v21ImageSource: "/our-best-work-v2.1.mov",
    v22ImageSource: "/our-best-work-v2.2.mov",
  },
  {
    label: "Our Partners",
    section: "our-partners",
    version: "none",
    order: 11,
  },
  {
    label: "Reviews",
    section: "reviews",
    version: "v2",
    order: 12,
    v2ImageSource: "/review-v2.png",
    v21ImageSource: "/review-v2.1.png",
  },
  {
    label: "Pay Online",
    section: "pay-online",
    version: "none",
    order: 13,
  },
  {
    label: "FAQ",
    section: "faq",
    version: "v2",
    order: 14,
  },
  {
    label: "Service Areas",
    section: "service_areas",
    version: "v2",
    order: 15,
    v2ImageSource: "/service-areas-v2.png",
    v21ImageSource: "/service-areas-v2.1.png",
  },
  {
    label: "Final CTA",
    section: "final-cta",
    version: "v2",
    order: 16,
    v2ImageSource: "/final-cta-v2.png",
    v21ImageSource: "/final-cta-v2.1.png",
  },
  {
    label: "Footer",
    section: "footer",
    version: "v2",
    order: 17,
  },
  {
    label: "Text Us Button",
    section: "text-us-button",
    version: "v2",
    order: 18,
    // v2ImageSource: "/text-us-button-v2.mov",
    // v21ImageSource: "/text-us-button-v2.1.mov",
  },
  {
    label: "Services Page",
    section: "services-page",
    version: "v2",
    order: 19,
    v2ImageSource: "/services-v2.png",
    v21ImageSource: "/services-v2.1.png",
  },
  {
    label: "Gallery Page",
    section: "gallery-page",
    version: "v2",
    order: 20,
    v2ImageSource: "/galleries-v2.png",
    v21ImageSource: "/galleries-v2.1.png",
  },
  {
    label: "Reviews Page",
    section: "reviews-page",
    version: "v2",
    order: 21,
    v2ImageSource: "/reviews-page-v2.png",
    v21ImageSource: "/reviews-page-v2.1.png",
  },
  {
    label: "Jobs Page",
    section: "jobs-page",
    version: "v2",
    order: 22,
    v2ImageSource: "/jobs-v2.png",
    v21ImageSource: "/jobs-v2.1.png",
  },
  {
    label: "Team Page",
    section: "team-page",
    version: "v2",
    order: 23,
  },
  {
    label: "Custom Page",
    section: "custom-page",
    version: "none",
    order: 24,
  },
  {
    label: "Blog Page",
    section: "blog-page",
    version: "v2",
    order: 25,
  },
  {
    label: "Text Us Modal",
    section: "modals/text_us",
    version: "v2",
    order: 26,
    v2ImageSource: "/text-us-modal-v2.png",
    v21ImageSource: "/text-us-modal-v2.1.png",
  },
  {
    label: "Text Thank You Modal",
    section: "modals/text_thank_you",
    version: "v2",
    order: 27,
  },
  {
    label: "Leave a Review Modal",
    section: "modals/leave_a_review",
    version: "v2",
    order: 28,
  },
];

export const pages = [
  {
    label: "Services Page",
    section: "services-page",
    version: "v2",
    order: 0,
    v2ImageSource: "/services-v2.png",
    v21ImageSource: "/services-v2.1.png",
  },
  {
    label: "Gallery Page",
    section: "gallery-page",
    version: "v2",
    order: 1,
    v2ImageSource: "/galleries-v2.png",
    v21ImageSource: "/galleries-v2.1.png",
  },
  {
    label: "Reviews Page",
    section: "reviews-page",
    version: "v2",
    order: 2,
    v2ImageSource: "/reviews-page-v2.png",
    v21ImageSource: "/reviews-page-v2.1.png",
  },
  {
    label: "Jobs Page",
    section: "jobs-page",
    version: "v2",
    order: 3,
    v2ImageSource: "/jobs-v2.png",
    v21ImageSource: "/jobs-v2.1.png",
  },
  {
    label: "Team Page",
    section: "team-page",
    version: "v2",
    order: 4,
  },
  {
    label: "Custom Page",
    section: "custom-page",
    version: "none",
    order: 5,
  },
  {
    label: "Blog Page",
    section: "blog-page",
    version: "v2",
    order: 6,
  },
];

export const parkUserWebsiteProsite = async (
  domain: string,
  park_type: "Involuntary Churn" | "Voluntary Churn" | "No Message"
) => {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/api/park_user_website`,
    {
      domain,
      park_type,
    }
  );
  return response.data;
};

export const getDefaultCustomLayout = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/api/get_custom_layout_presets/default`
  );

  return response.data.message;
};

export const getDefaultCustomCSS = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/api/get_custom_css_presets/default`
  );

  return response.data.message;
};

export const purchaseDomainHelper = async (domain: string, slug: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/purchase-domain`,
      { domain, slug }
    );
    return response.data.message;
  } catch (error) {
    return "error";
  }
};

export const checkDomainAvailability = async (domain: string, slug: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/check-domain-availability`,
      { domain, slug }
    );
    return response.data.message;
  } catch (error) {
    return "error";
  }
};

export const configureDNSHelper = async (domain: string, slug: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/configure-dns`,
      { domain, slug }
    );
    return response.data.status;
  } catch (error) {
    return "error";
  }
};

export const configureForExtDns = async (domain: string, slug: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/configure-for-ext-domain`,
      { slug }
    );
    return response?.data?.message;
  } catch (error) {
    return "error";
  }
};

export const createDnsSnapshot = async (domain: string, slug: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/domain-dns-snapshot`,
      { paid_url: domain, slug }
    );
    return response.data.status;
  } catch (error) {
    return "error";
  }
};

export const DOMAIN_REGEX = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}?$/;
export const DOMAIN_DISALLOWED_REGEX = /[^a-zA-Z0-9.-]/g;
export const SLUG_REGEX = /^[\w-]+$/;
export const SLUG_DISALLOWED_REGEX = /[^\w-]/g;

export const isDomainValid = (domain: string): boolean => {
  return DOMAIN_REGEX.test(domain);
};

export const isSlugValid = (slug: string): boolean => {
  return SLUG_REGEX.test(slug) && !slug.includes(".");
};
